$shm_projects_goal $mol_view
	project_id \
	version \
	ask_questions? false
	result_visible false
	output_mode? \process
	after /
	sub /
		<= Form $mol_view
			sub <= goal_form /
	Process $shm_projects_goal_chat
		run <= run_data? null
		iteration <= selected_iteration_number 0
		prerelease <= prerelease_selected false
		version <= version \
		workspace_id <= result_workspace_id \base
		clarifications <= goal_process_clarifications /
		after <= goal_result_after /
	Result $mol_view
		sub <= goal_result /
	Thinking $shm_projects_goal_thinking
	Send $mol_button_major
		title \Отправить
		enabled <= send_enabled true
		click? <=> send? null
	Requirements_draft $shm_projects_goal_request
		Field => Requirements_field -
		label <= requirements_label \
		requirements true
		value? <=> requirements? \
		attachments? <=> requirements_attachments? /
		after /
			<= Ask_questions $mol_check_box
				title \Задавать вопросы
				checked? <=> ask_questions?
			<= Send
	Timeline $mol_list
		rows <= timeline_rows /
	Clarifications $mol_view
		sub <= clarifications_content /
	Clarifications_title $mol_view
		sub / \Уточнения перед началом работы
	Clarifications_list $mol_list
		rows <= clarification_rows /
	Clarifications_send $mol_button_major
		title \Продолжить
		enabled <= clarifications_send_enabled true
		click? <=> clarifications_send? null
	Clarification* $mol_form_field
		name <= clarification_question* \
		Content <= clarification_answer_content* null
	Clarification_answer* $mol_textarea
		value? <=> clarification_answer*? \
	Clarification_answer_text* $mol_text
		text <= clarification_answer* \
	Prerelease_status $mol_view
		sub <= prerelease_status_content /
	Prerelease_status_head $mol_view
		sub /
			<= Prerelease_status_link $mol_link
				arg <= prerelease_result_arg *
				title \Пререлиз
				sub / \Пререлиз
				click? <=> prerelease_select? null
			<= Prerelease_status_state $mol_text
				text <= prerelease_status_state \
			<= Prerelease_status_elapsed $mol_text
				text <= prerelease_status_elapsed \
	Iteration_status* $mol_view
		sub <= iteration_status_content* /
	Iteration_status_head* $mol_view
		sub <= iteration_status_rows* /
	Iteration_status_title* $mol_view
		sub / <= iteration_status_title* \
	Iteration_status_link* $mol_link
		arg <= result_iteration_arg* *
		title <= iteration_status_title* \
		sub / <= iteration_status_title* \
		click? <=> iteration_select*? null
	Iteration_status_state* $mol_text
		text <= iteration_status_state* \
	Iteration_status_elapsed* $mol_text
		text <= iteration_status_elapsed* \
		attr *
			^
			title <= iteration_status_elapsed_details* \
	Iteration_rollback* $mol_button_minor
		title \Откатить эту и следующие
		click? <=> iteration_rollback*? null
	Iteration_goal* $mol_form_field
		rows <= iteration_goal_rows* /
		name <= iteration_goal_label* \
		Content <= Iteration_goal_text* $mol_text
			text <= iteration_goal_text* \
	Stop $mol_button_minor
		title \Остановить
		click? <=> stop? null
	Continue $mol_button_major
		title \Продолжить
		click? <=> continue? null
	Rollback_all $mol_button_minor
		title \Откатить все итерации
		click? <=> rollback_all? null
	Iterations $mol_list
		rows <= iteration_rows /
	Iteration* $mol_view
		sub <= iteration_content* /
	Iteration_title* $mol_view
		sub / <= iteration_title* \
	Iteration_events* $mol_list
		rows <= iteration_event_rows* /
	Iteration_event* $mol_text
		text <= iteration_event_text* \
	Iteration_summary* $mol_text
		text <= iteration_summary* \
	Iteration_changes* $mol_view
		sub <= iteration_change_rows* /
	Prerelease $mol_view
		sub <= prerelease_content /
	Prerelease_title $mol_view
		sub / \Пререлиз
	Prerelease_state $mol_text
		text <= prerelease_state \
	Prerelease_external_note $mol_text
		text <= prerelease_external_note \
	Prerelease_events $mol_list
		rows <= prerelease_event_rows /
	Prerelease_event* $mol_text
		text <= prerelease_event_text* \
	Prerelease_summary $mol_text
		text <= prerelease_summary \
	Prerelease_changes $mol_view
		sub <= prerelease_change_rows /
	Prerelease_change* $mol_view
		sub <= prerelease_change_content* /
	Prerelease_change_title* $mol_view
		sub / <= prerelease_change_title* \
	Prerelease_change_description* $mol_text
		text <= prerelease_change_description* \
	Prerelease_change_screenshots* $mol_view
		sub <= prerelease_change_screenshot_rows* /
	Prerelease_change_screenshot* $mol_link
		uri <= prerelease_change_screenshot_uri* \
		external true
		sub /
			<= Prerelease_change_screenshot_image* $mol_image
				uri <= prerelease_change_screenshot_uri* \
				loading \eager
				decoding \sync
	Prerelease_stop $mol_button_minor
		title \Остановить
		click? <=> stop? null
	Prerelease_continue $mol_button_major
		title \Повторить проверку
		click? <=> prerelease_continue? null
	Prerelease_accept_external $mol_button_minor
		title \Продолжить при внешней ошибке
		click? <=> prerelease_accept_external? null
	Result_change* $mol_view
		sub <= result_change_content* /
	Result_change_title* $mol_view
		sub / <= result_change_title* \
	Result_change_description* $mol_text
		text <= result_change_description* \
	Result_change_screenshots* $mol_view
		sub <= result_change_screenshot_rows* /
	Result_change_screenshot* $mol_link
		uri <= result_change_screenshot_uri* \
		external true
		sub /
			<= Result_change_screenshot_image* $mol_image
				uri <= result_change_screenshot_uri* \
				loading \eager
				decoding \sync
	Refine $mol_button_major
		title \Отправить на доработку
		click? <=> refine? null
	Refinement_draft $shm_projects_goal_request
		Field => Refinement_field -
		label <= refinement_label \
		refinement true
		value? <=> refinement? \
		attachments? <=> refinement_attachments? /
		after /
			<= Refinement_ask_questions $mol_check_box
				title \Задавать вопросы
				checked? <=> ask_questions?
			<= Refine
	Artifacts $mol_list
		rows <= artifact_rows /
	Artifact* $mol_link
		uri <= artifact_uri* \
		external true
		title <= artifact_title* \
		sub / <= artifact_title* \
